/**
 * Labels and formatting for support tickets (Administration → Tickets).
 */

import type { TicketOut, TicketStatus } from "@/shared/api/tickets";

export const STATUS_LABEL: Record<TicketStatus, string> = {
  open: "Open",
  in_progress: "In progress",
  resolved: "Resolved",
  closed: "Closed",
};

const EMAIL_LABEL: Record<TicketOut["email_status"], string> = {
  pending: "Pending",
  sent: "Sent",
  failed: "Failed",
  not_configured: "Not configured",
};

export function emailStatusLabel(status: TicketOut["email_status"]): string {
  return EMAIL_LABEL[status];
}

export function askedBy(ticket: TicketOut): string {
  return ticket.created_by_display_name ?? ticket.created_by_email ?? "Unknown user";
}

export function formatUtc(iso: string): string {
  return `${iso.slice(0, 16).replace("T", " ")} UTC`;
}
